import { render, staticRenderFns } from "./VerkInvoiceAccList.vue?vue&type=template&id=1d21655f&scoped=true&"
import script from "./VerkInvoiceAccList.vue?vue&type=script&lang=ts&"
export * from "./VerkInvoiceAccList.vue?vue&type=script&lang=ts&"
import style0 from "./VerkInvoiceAccList.vue?vue&type=style&index=0&id=1d21655f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d21655f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
